import React, { useContext } from 'react';
import { ProductContext } from "./ProductContext"; 
import disclaimerData from "./data/Disclaimer.json";
import "./Disclaimer.css";

const Disclaimer = () => {

  const { selectedLanguage } = useContext(ProductContext);  
  const disclaimerContent = disclaimerData[selectedLanguage] || disclaimerData["en"];
  
  return (
    <div className="page-container">
      <div style={{ height: '1px', backgroundColor: '#ccc', margin: '32px 0' }} />
      <div className="disclaimer-container">
      <h2 className="disclaimer-title">{disclaimerContent.title}</h2>
        {disclaimerContent.content.map((paragraph, index) => {
          if (typeof paragraph === 'object' && paragraph !== null) {
            const { section, text } = paragraph;
            return (
              <div key={index}>
                {section && <h3 className="disclaimer-section-title">{section}</h3>}
                {text && <p className="disclaimer-text">{text}</p>}
              </div>
            );
          } else {
            return <p key={index} className="disclaimer-text">{paragraph}</p>;
          }
        })}
      </div>
      <div style={{ height: '1px', backgroundColor: '#ccc', margin: '32px 0' }} />
      <footer className="footer">
        <p>&copy; 2025 Ferreira Business Intelligence Inc. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Disclaimer;
